import React from "react";

interface BubbleChatProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text: string,
    color:string|undefined
}

const TestimonyBubbleChat: React.FC<BubbleChatProps> = ({text, color}) => {
    return(
        <div className="relative">
            <div className=" text-sm rounded-3xl p-4 w-[250px] h-[90px] break-words border text-black bg-white" style={{borderColor:color}}>
            <i>{text}</i>
            </div>
        
        </div>
    );
}

export default TestimonyBubbleChat;